import IApplication from "./IApplication";
import ApplicationBase from "./ApplicationBase";
import State from "../dto/StateEnum";
import StateReason from "../dto/StateReasonEnum";
import IWorkflowStep from "../dto/IWorkflowStep";

export default class Application extends ApplicationBase implements IApplication {
    constructor(
        public customerKey: string,
        id: string,
        state: State,
        stateReason: StateReason,
        workflowSteps?: IWorkflowStep[]
    ) {
        super(id, state, stateReason, workflowSteps);
    }
}
